import { useCrudActions } from '@/common/view/useCrudActions';
import { translationService } from '@/services/translation';
import FileSaver from 'file-saver';
import { reactive } from 'vue';

export function useTranslationExport() {
    const crudAction = useCrudActions();

    const model = reactive({
        file: null
    });

    const exportXml = crudAction.excuteAndNotify({
        request: translationService.export,
        onSuccess: ({ data }) => {
            const blob = new Blob([data], { type: 'text/xml;charset=utf-8' });
            FileSaver.saveAs(blob, 'translation.xml');
        }
    });
    const importXml = crudAction.excuteAndNotify({
        canExecute: () => model.file != null,
        request: () => translationService.import(model.file),
        onSuccess: () => (model.file = null)
    });

    return { model, fetch, exportXml, importXml };
}
